// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview76BindJs from "./DragPreview76.bind.js";

var make = DragPreview76BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
